module.exports = __webpack_public_path__ + "media/thenoise.f94c51b7.mp3";